export default "__VITE_ASSET__Bz77gQDu__"